import { Request } from '~src/httpClient/serverApi/requests/Request';

import { ISiteMetadata } from '../types/ISiteMetadata';

export class GetSiteMetadataRequest extends Request<{}, ISiteMetadata> {
  constructor() {
    super('getLandingPageSiteMetadata', {});
  }
}